import { create } from "zustand";
import { TransactionUpdateStatusList } from "../models/Response/transactionUpdateStatusResponse";
import { WalletUpdateStatus } from "./app.store";

interface RealTimeStore {

  // 🔥 Latest real-time events (NOT full lists)
  latestWithdrawUpdate: WalletUpdateStatus | null;
  latestDepositUpdate: WalletUpdateStatus | null;
  latestDocumentUpdate: WalletUpdateStatus | null;
  latestBankUpdate: WalletUpdateStatus | null;

  // Flags
  withdrawRevertAllowed: boolean;
  depositRevertAllowed: boolean;

  // Transaction modal queue
  transactionQueue: TransactionUpdateStatusList[];

  // Message counter
  messageCount: number;

  // Actions
  setLatestWithdrawUpdate: (data: WalletUpdateStatus) => void;
  setLatestDepositUpdate: (data: WalletUpdateStatus) => void;
  setLatestDocumentUpdate: (data: WalletUpdateStatus) => void;
  setLatestBankUpdate: (data: WalletUpdateStatus) => void;

  addTransactionUpdate: (item: TransactionUpdateStatusList) => void;
  removeFirstTransaction: () => void;

  setWithdrawRevert: (isOn: boolean) => void;
  setDepositRevert: (isOn: boolean) => void;

  incrementMessageCount: () => void;
}

export const useRealTimeStore = create<RealTimeStore>((set) => ({

  // 🔥 Only store latest event
  latestWithdrawUpdate: null,
  latestDepositUpdate: null,
  latestDocumentUpdate: null,
  latestBankUpdate: null,

  withdrawRevertAllowed: false,
  depositRevertAllowed: false,

  transactionQueue: [],
  messageCount: 0,

  setLatestWithdrawUpdate: (data) =>
    set({ latestWithdrawUpdate: data }),

  setLatestDepositUpdate: (data) =>
    set({ latestDepositUpdate: data }),

  setLatestDocumentUpdate: (data) =>
    set({ latestDocumentUpdate: data }),

  setLatestBankUpdate: (data) =>
    set({ latestBankUpdate: data }),

  addTransactionUpdate: (item) =>
    set((state) => {

      const exists = state.transactionQueue.some(
        x =>
          x.id === item.id &&
          x.remarkstemplatecontent === item.remarkstemplatecontent &&
          x.remarkshindicontent === item.remarkshindicontent
      );

      if (exists) return state;

      return {
        transactionQueue: [...state.transactionQueue, item],
      };
    }),

  removeFirstTransaction: () =>
    set((state) => ({
      transactionQueue: state.transactionQueue.slice(1),
    })),

  setWithdrawRevert: (isOn) =>
    set({ withdrawRevertAllowed: isOn }),

  setDepositRevert: (isOn) =>
    set({ depositRevertAllowed: isOn }),

  incrementMessageCount: () =>
    set((state) => ({
      messageCount: state.messageCount + 1,
    })),
}));
